import gsap from 'gsap';

export default class ShowLines {
    show(id) {
        const lines = document.querySelectorAll(`#${id} .txt div p`);

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: document.querySelector(`#${id}`),
                start: 'top 66%'
            }
        });
        tl.from(
            Array.from(lines),
            {
                ease: "power4.out",
                duration: 1.25,
                y: '100%',
                stagger: .1,
                delay: .5
            }
        );
    }
}